import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MyCompanyAccountService } from 'src/app/services/feature/myCompanyAccount/my-company-account.service';

@Component({
  selector: 'app-delete-user-confirm-dialog',
  templateUrl: './delete-user-confirm-dialog.component.html',
  styleUrls: ['./delete-user-confirm-dialog.component.scss'],
  standalone: false
})
export class DeleteUserConfirmDialogComponent {
  subscription = new Subscription();
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any, private myCompanyAccountService: MyCompanyAccountService,
    public dialogRef: MatDialogRef<DeleteUserConfirmDialogComponent>,) {
  }

  delUser() {
    this.subscription.add(this.myCompanyAccountService.deleteUser(this._data).subscribe(data => {
      this.dialogRef.close(data);
    }))
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
